export default __webpack_public_path__ + "static/media/bus.010cfc67.png";